import '@babel/polyfill'
import Vue from 'vue'
import './plugins/moment'
import './plugins/meta'
import App from './App'
import router from './router'
import './mixins/trailer'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations'

if (window.envConfig.UI_SENTRY_DSN) {
    Sentry.init({
      Vue: Vue,
      dsn: window.envConfig.UI_SENTRY_DSN,
      release: window.envConfig.BUILD_VERSION,
      environment: window.envConfig.SENTRY_ENVIRONMENT || 'stage',
      logErrors: true,
      tracingOptions: {
        trackComponents: true,
      },
      integrations: [
        new Integrations.BrowserTracing(),
        new CaptureConsoleIntegration({
          // array of methods that should be captured
          // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
          levels: ['warn', 'error', 'assert'],
        }),
      ],
    })
  }

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: 'UA-116916364-5',
    router
})

import autofocus from 'vue-autofocus-directive';
Vue.directive('autofocus', autofocus);

import SmartImg from './components/SmartImg.vue'
Vue.component('smart-img', SmartImg)
Vue.mixin({
    methods: {
        generateSmartImgUrl: function (src, preset = null, factor = null) {
            return SmartImg.methods.generateUrl(src, preset, factor)
        }
    }
})

import DatePicker from './components/DatePicker.vue'
Vue.component('date-picker', DatePicker)

import PnoLoading from './components/PnoLoading.vue'
Vue.component('pno-loading', PnoLoading)

import { L, LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

import Storage from 'vue-ls';
Vue.use(Storage, {
    namespace: 'pno__', // key prefix
    name: 'localStorage', // name variable Vue.[localStorage] or this.[$localStorage],
    storage: 'local', // storage name session, local, memory
});

const store = require('./store').default

Vue.config.productionTip = false

// Start timer. Provides a reactive timestamp, updated each second
store.dispatch('time/start')

import ErrorPage from 'vue-error-page';

window.eventBus = new Vue()

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

Vue.use(ErrorPage)

// Load permissions for current user
store.dispatch("user/loadUser")
.finally(function () {
    const userPermissions = store.state.user.claims.permissions ? store.state.user.claims.permissions : []
    if (store.state.user.isLoggedIn) {
        userPermissions.push('loggedin')
        if (store.state.user.claims) {
            Sentry.setUser({
                email: store.state.user.claims.sub,
                id: store.state.user.claims.user_id,
                username: store.state.user.claims.sub,
            })
        }
    }
    router.setPermissions(userPermissions)
    // Launch vue app!
    window.Vue = new Vue({
        el: "#app",
        render: h => h(App),
        router,
        store,
    })
})
